import React from "react";
import '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faAws } from '@fortawesome/free-brands-svg-icons';

// ✅ Solid icon (ChalkboardTeacher)
import { faChalkboardTeacher } from '@fortawesome/free-solid-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "React.js",
    "Next.js",
    "JavaScript (ES6+)",
    "TypeScript",
    "HTML5",
    "CSS3",
    "Tailwind CSS",
    "Bootstrap",
    "Redux Toolkit",
    "Axios",
    "RESTful APIs",
    "MongoDB",
    "Express.js",
    "Node.js",
    "Mongoose"
];

const labelsSecond = [
    "Git & GitHub",
    "Postman",
    "CI/CD (GitHub Actions)",
    "Docker",
    "AWS",
    "Render / Vercel",
    "VS Code",
    "Figma",
    "Responsive Design",
    "Testing (Manual & Automation)",
    "Technical Documentation"
];

const labelsThird = [
    "Go-to-Market (GTM) Strategy",
    "Campaign Management",
    "Marketing & Growth Strategy",
    "YouTube Channel Optimization",
    "Audience Engagement & Retention",
    "Vendor & Inventory Management",
    "Financial Workflow Coordination",
    "Data-Driven Decision Making",
    "Educational Content Operations",
    "Customer Satisfaction (NPS Improvement)"
];

function Expertise() {
    return (
        <div className="container" id="expertise">
            <div className="skills-container">
                <h1>Expertise</h1>
                <div className="skills-grid">

                    {/* Full Stack Web Development */}
                    <div className="skill">
                        <FontAwesomeIcon icon={faReact} size="3x" />
                        <h3>Full Stack Web Development</h3>
                        <p>
                            I specialize in developing dynamic, responsive, and user-friendly web applications using the MERN stack.
                            My focus is on building seamless frontend-backend integration with clean, maintainable code.
                        </p>
                        <div className="flex-chips">
                            <span className="chip-title">Tech stack:</span>
                            {labelsFirst.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>

                    {/* DevOps & Project Management */}
                    <div className="skill">
                        <FontAwesomeIcon icon={faAws} size="3x" />
                        <h3>DevOps & Project Management</h3>
                        <p>
                            I use tools and platforms that ensure efficient development workflows — from version control and
                            automated testing to deployment. My experience includes writing documentation and maintaining
                            clean CI/CD pipelines.
                        </p>
                        <div className="flex-chips">
                            <span className="chip-title">Tools & Platforms:</span>
                            {labelsSecond.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>

                    {/* Unacademy & EdTech Expertise */}
                    <div className="skill">
                        <FontAwesomeIcon icon={faChalkboardTeacher} size="3x" />
                        <h3>Teaching & EdTech (Unacademy)</h3>
                        <p>
                            During my time at Unacademy, I developed strong mentoring and communication skills.
                            I created engaging educational content, guided learners, and integrated modern EdTech tools
                            to improve the overall learning experience.
                        </p>
                        <div className="flex-chips">
                            <span className="chip-title">Key Skills:</span>
                            {labelsThird.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Expertise;
